// Chart1.js
import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

// Registro de los elementos necesarios
ChartJS.register(ArcElement, Tooltip, Legend, Title);

// Colores de ejemplo
const CHART_COLORS = {
  //red: "#FF6384",
  orange: "#FF9F40",
  //yellow: "#FFCD56",
  //green: "#4BC0C0",
  blue: "#36A2EB"
};

// Datos base simulados
const data = {
  labels: ["Orange", "Blue"],
  datasets: [
    {
      label: "Dataset 1",
      data: [12, 3, ],
      backgroundColor: Object.values(CHART_COLORS),
    },
  ],
};

// Opciones de configuración
const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Chart.js Doughnut Chart",
    },
  },
};

const Chart1 = () => {
  return <Doughnut data={data} options={options} />;
};

export default Chart1;
